import { action, orchestrator, mutatorAction } from 'satcheljs';
import { trace } from 'owa-trace';
import { isConsumer } from 'owa-session-store';
import getPhoneNumber from './getPhoneNumber';
import getStore from './store';
import getTextMessagingAccountService from '../services/getTextMessagingAccountService';
import setTextMessagingAccountData from './setTextMessagingAccountData';

const loadTextMessagingAccount = action('loadTextMessagingAccount');
export default loadTextMessagingAccount;

const setIsHidden = mutatorAction('setIsHidden', (value: boolean) => {
    getStore().isHidden = value;
});

orchestrator(loadTextMessagingAccount, async () => {
    if (!isConsumer()) {
        const response = await getTextMessagingAccountService();

        if (response.WasSuccessful) {
            setTextMessagingAccountData(response.Data);
            setIsHidden(!getPhoneNumber());
        } else {
            trace.error(response.ErrorMessage);
        }
    }
});
